import { render, staticRenderFns } from "./DetalhesCompra.vue?vue&type=template&id=151dc030&"
import script from "./DetalhesCompra.vue?vue&type=script&lang=js&"
export * from "./DetalhesCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports